import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import Barcode from "react-barcode";
import html2canvas from "html2canvas";
import ReactToPrint from "react-to-print";

import {
  Form,
  Input,
  InputNumber,
  Checkbox,
  Button,
  Col,
  Row,
  Select,
  message,
  TreeSelect,
  Divider,
  Drawer,
} from "antd";

const { Option } = Select;

const BarcodePrinter = ({ details, variation }) => {
  const wrapper_ref = React.useRef();
  const componentRef = useRef();

  var formatter = new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "BDT",
  });

  const printt = () => {
    const opt = {
      scale: 4,
    };

    const elem = wrapper_ref.current;
    html2canvas(elem, opt).then((canvas) => {
      const iframe = document.createElement("iframe");
      iframe.name = "printf";
      iframe.id = "printf";
      iframe.height = 0;
      iframe.width = 0;
      document.body.appendChild(iframe);

      const imgUrl = canvas.toDataURL({
        format: "jpeg",
        quality: "1.0",
      });
      
      let page = `<div  >`;
      // console.log(details);
      // for (let i =  0; i < variation.quantity; i++) {
        page += `<div class="flex-container">
        <div class="grid-item "><p style="margin-top:0px;"><b></b></p></div>
        <div class="grid-item "><p style="margin-top:5px; font-size: 12px;font-weight:700; letter-spacing:3px;"><b>SHIRTEX</b></p></div>
        <div class="grid-item" >
          <p style="margin-top:-15px;margin-bottom: -2px;font-size: 10px;letter-spacing: 3px;">
            <b>${variation.product_code}</b>
          </p>
          <p style="margin-top:2px;margin-bottom: 0px;font-size: 10px; letter-spacing: 3px;font-weight:800;">
            <b>${variation.title} | ${variation.size}</b>
          </p>
  
           <img width="95%" src="${imgUrl}"/>    
        </div>
        <div class="grid-item "><p style="margin-top:-5px;margin-bottom: 0px;font-size: 12px;font-weight:700;"><b>${formatter.format(
          variation.selling_price
        )}</b></p></div> 
       `;
        // }
        page += "</div>"
      // console.log(page);
      // console.log(variation.length);

      var newWin = window.frames["printf"];
      newWin.document.write(
        `<body onload="window.print()"><style>
        @page { size: auto;  margin: 0mm;  }
        
.grid-container {
  display: grid;
  grid-auto-flow: row;
  background-color: #2196F3;

  margin: auto;
}

.flex-container {
  display: flex;
  flex-direction: column;
  margin-bottom:-5px;
}

.grid-item {
  // background-color: rgba(255, 255, 255, 0.8);
  font-size: 10px;
  text-align: center;
  margin-top: auto;
  margin-bottom: auto;
}

        </style>${page}</body>`
      );
      newWin.document.close();
      return page;
    });
  };

  // <h4 style="margin: 0px; font-size: 20px">${
  //   details.product_code
  // }-${i}</h4>
  return (
    <>
      <div ref={wrapper_ref}>
        <Barcode width={3} height={55} fontSize={14} format="CODE128" value={variation.barcode} />
      </div>
      <Button onClick={printt}>Print Barcode</Button>
    </>
  );
};

export default connect()(BarcodePrinter);



{/* <p style="margin-top:0px;margin-bottom: 0px;">
      ${variation.product_code}
    </p>
  <text>(VAT inclusive)</text>

        <p style="margin-top:2px;margin-bottom: 2px;font-size: 10px;">
          <b>${variation.product_code} -- ${variation.size}</b>
        </p>

      // HORIZONTAL
      page += `<div class="flex-container">
      <div class="grid-item "><p style="font-size: 20px;"><b>SHIRTEX</b></p></div>
      <div class="grid-item " >
        <p style="margin-top:0px;margin-bottom: 0px;font-size: 16px;">
          <b>Style: ${variation.title} // ${variation.product_code} // ${variation.size}</b>
        </p>

         <img width="95%" src="${imgUrl}"/>    
      </div>
      <div class="grid-item "><h6 style="margin-top:0px;margin-bottom: 1px;font-size: 18px;"><b>${formatter.format(
        variation.selling_price
      )}</b></h6></div> 
     `;
      // }
      page += "</div>"

      // VERTICAL 
      let page = `<div  >`;
      // console.log(details);
      // for (let i =  0; i < variation.quantity; i++) {
      page += `<div class="flex-container">
      <div class="grid-item "><p style="font-size: 34px;"><b>SHIRTEX</b></p></div>
      <div class="grid-item " >
      <p style="margin-top:0px;margin-bottom:0px;font-size: 22px;">
     <b>${variation.product_code}</b>
    </p>
    <p style="margin-top:2px;margin-bottom: 10px;font-size: 20px;">
      <b>${variation.title} -- ${variation.size}</b>
    </p>
    
    <img style="" width="90%" src="${imgUrl}"/>
    
      </div>
      <div class="grid-item "><h6 style="margin-top:10px;margin-bottom: 1px;font-size: 22px;"><b>${formatter.format(
        variation.selling_price
      )}</b></h6></div> 
     `;
      // }
      page += "</div>"

 */}
